 var translation = null;

    const gettext = function (text) {
        let res = null;
        console.warn('Using gettext is a deprecated method!');
        if (translation === null || text === null || text in translation === false) {
            return $('<div/>').html(text).text();
        }
        res = translation[text];
        if (res === null) {
            return $('<div/>').html(text).text();
        }
        return res;
    };

    gettext.gettext = gettext;

    gettext.setTranslation = function(t) {
        translation = t;
    };

export default gettext;
